import { render, staticRenderFns } from "./Creators2.vue?vue&type=template&id=585bc840&"
import script from "./Creators2.vue?vue&type=script&lang=js&"
export * from "./Creators2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports